import { StaffActivityPayload, Staffs } from '@/modules/staffs/types';
import { Actions } from 'vuex-smart-module';
import { ReportsTypes } from '@/enums';
import { Filters } from '@/types';
import { StaffsService } from '../../../services';
import StaffDetailGetters from './getters';
import StaffDetailMutations from './mutations';
import StaffDetailState from './state';

const staffService = new StaffsService();

export default class StaffDetailActions extends Actions<
  StaffDetailState,
  StaffDetailGetters,
  StaffDetailMutations,
  StaffDetailActions
> {
  async get_staff(id: string | number) {
    try {
      const { data, code } = await staffService.get_staff(id);

      this.mutations.SET_CURRENT_STAFF(data);

      return code;
    } catch (error) {
      console.log(error);
    }
  }

  async update_staff() {
    try {
      const { editable_staff } = this.state;
      const permissions = editable_staff.permissions?.reduce(
        (acc, { slug, is_allowed }) => ({ ...acc, [slug]: is_allowed }),
        {},
      );
      const { success } = await staffService.upd_staff({
        ...editable_staff,
        permissions: editable_staff.permissions?.length ? permissions : {},
      });

      this.mutations.SET_CURRENT_STAFF(editable_staff);
      this.mutations.RESET_EDITABLE_STAFF();
      return success;
    } catch (error) {
      console.log(error);
    }
  }

  async toggle_activity_staff(payload: StaffActivityPayload) {
    try {
      const { success = true } = await staffService.toggle_activity_staff(payload);

      return success;
    } catch (error) {
      console.log(error);
    }
  }

  async get_compatible_roles() {
    try {
      const payload: Filters = {
        filters: this.state.filters,
      };

      this.mutations.TOGGLE_ROLES_LOADING(true);

      const { data } = await staffService.get_compatible_roles(payload);

      this.mutations.SET_COMPATIBLE_ROLES(data.items);
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_ROLES_LOADING(false);
    }
  }
}
